<template>
  <div>
    <div class="grid bg-white mt-50">
      <div class="grid-body p-20">
        <div class="row">
          <div class="col-md-6 p-14 text-left">
            Calculate Base On Last <br />
            <div class="row">
              <div class="col-md-6">
                <p-radio
                  class="p-default"
                  :value="12"
                  name="timePeriod"
                  @change="paramChanged()"
                  v-model="serverParams.saleGraph.lastXMonths"
                  color="success"
                >
                  1 Year
                </p-radio>
              </div>
              <div class="col-md-6">
                <p-radio
                  class="p-default"
                  :value="6"
                  name="timePeriod"
                  @change="paramChanged()"
                  v-model="serverParams.saleGraph.lastXMonths"
                  color="success"
                >
                  6 Months
                </p-radio>
              </div>
              <div class="col-md-6">
                <p-radio
                  class="p-default"
                  :value="3"
                  name="timePeriod"
                  @change="paramChanged()"
                  v-model="serverParams.saleGraph.lastXMonths"
                  color="success"
                >
                  3 Months
                </p-radio>
              </div>
              <div class="col-md-6">
                <p-radio
                  class="p-default"
                  :value="1"
                  name="timePeriod"
                  @change="paramChanged()"
                  v-model="serverParams.saleGraph.lastXMonths"
                  color="success"
                >
                  1 Months
                </p-radio>
              </div>
            </div>
          </div>
          <div class="col-md-6 text-right">
            <h4 class="text-bold">Fabric Sales in Meters per week</h4>
          </div>
        </div>
      </div>

      <div id="line chart" class="grid-body p-8">
        <div class="text-center line-chart-container mt-10"></div>
      </div>
    </div>
  </div>
</template>

<script>
import chart from "@/pages/Tools/Chart";
export default {
  props: ["pageData", "serverParams"],
  methods: {
    paramChanged() {
      this.$emit("changed", 1);
    },
  },
  watch: {
    "pageData.fabricSaleGraph": function () {
      let labels = this.pageData.fabricSaleGraph.labels;
      let data = this.pageData.fabricSaleGraph.total_sales;

      let dataSets = [
        {
          label: "Fabric Usage",
          backgroundColor: "red",
          borderColor: "#5e72e4",
          fill: false,
          data,
        },
      ];
      chart.lineChart(labels, dataSets, 120, {
        legend: { display: 0 },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Weeks",
              },
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Meter",
              },
            },
          ],
        },
      });
    },
  },
};
</script>
